import { ObjectMapper } from "json-object-mapper";

export class ComptimeEmployeeHistoryModel {
  events: any[] = [];
  registration: string = '';
  name: string[] = [];
  balance: number = 0;
  income: number = 0;
  discount: number = 0;

  static create(input: any): ComptimeEmployeeHistoryModel {
    return ObjectMapper.deserialize<ComptimeEmployeeHistoryModel>(ComptimeEmployeeHistoryModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}